export default angular.module('contartemx.preferencias.logo', [
    'contartemx',
    'ui.router',
    'ui.bootstrap'
])
.controller('LogoCtrl', function ($scope, $state, $stateParams, callToWebService, fileUploadService) {
        
     callToWebService.postCall('ObtenerPantallaLogo', {},
            function success(data){
               
                if(data.EsError || data.CodigoRespuesta==500)
                {
                   $scope.showMsg(data.Mensaje, 'error');
                }
                else
                {
                    var logos = data.Respuesta;
                    $scope.Logo=logos.Logo;
                    $scope.LogoAltaCalidad=logos.LogoAltaCalidad;
                }
            },

            function error(data){
                $scope.showMsg(data.Mensaje, 'error');
            });

       $scope.restaurarLogos = function($existelogo1, $existelogo2){
        var logos = {
                logo1: $existelogo1,
                logo2: $existelogo2
            };
       callToWebService.postCall('RestaurarLogos', logos,
            function success(data){
                
               if(data.EsError || data.CodigoRespuesta==500)
                {
                    $scope.showMsg(data.Mensaje, 'info');
                }
                else
                {
                    if(logos.logo1==true)
                    {
                        $scope.Logo="";
                        $scope.showMsg('Se removió satisfactoriamente el logo', 'info');
                        $state.transitionTo("preferencias.logo");
                    }

                    if(logos.logo2==true)
                        {
                         $scope.LogoAltaCalidad ="";
                         $scope.showMsg('Se removió satisfactoriamente el logo', 'info');
                         $state.transitionTo("preferencias.logo");
                     }
                    if(logos.logo1==true && logos.logo2)
                    {
                        $scope.Logo="";
                        $scope.LogoAltaCalidad="";
                        $scope.showMsg('Se restauraron satisfactoriamente los logos', 'info');
                        $state.transitionTo("preferencias.logo");
                    }
                    
                }
            },

            function error(data){
                $scope.showMsg(data.Mensaje, 'error');
            });
       };

        $scope.formSuccessCB = function(data)
        {
            if(data.EsError || data.CodigoRespuesta==500)
                {
                    if(data.Mensaje!==null || data.Mensaje!==undefined){
                       $scope.showMsg(data.Mensaje, 'error'); 
                    }
                    else
                    {
                        $scope.showMsg("Error al intentar guardar logos", "error");
                    }
                    
                }
                else
                {
                    var logos = data.Respuesta;
                    $scope.Logo=logos.Logo;
                    $scope.LogoAltaCalidad=logos.LogoAltaCalidad;
                    $scope.showMsg('Se guardaron satisfactoriamente los logos.', 'info');
                }
           
                
        };
        $scope.formErrorCB = function(data)
        {

            if(data.Mensaje!==undefined){
                $scope.showMsg(data.Mensaje, 'error');
            }
            else{
                $scope.showMsg("Error al intentar guardar logos","error");
            }
            
        };

        $scope.alert = [];
        $scope.showMsg = function(mensaje, tipo){
            $scope.alert = [];
            $scope.alert.push({type:tipo, msg:mensaje});
        };

        $scope.closeAlert = function(){
            $scope.alert = [];
        };
});
